import { combineReducers } from 'redux';

import { memberSliceReducer, MemberState, initialMemberState } from './member';
import {
  patientSliceReducer,
  PatientState,
  initialPatientState,
} from './patient';
import {
  partnershipSliceReducer,
  PartnershipState,
  initialPartnershipState,
} from './partnership';

export * from './member';
export * from './patient';

export type PartnerState = {
  member: MemberState;
  partnership: PartnershipState;
  patient: PatientState;
};

export const initialPartnerState: PartnerState = {
  member: initialMemberState,
  partnership: initialPartnershipState,
  patient: initialPatientState,
};

export const partnerReducers = combineReducers({
  member: memberSliceReducer,
  partnership: partnershipSliceReducer,
  patient: patientSliceReducer,
});
